import React, { useMemo } from "react";

import { Sparkles } from "lucide-react";

import { getTrialTimeRemaining } from "@needl-ai/common/utils/trial";

interface TrialExpirationAlertProps {
  trialExpiresAt: number;
  className?: string;
}

const TrialExpirationAlert: React.FC<TrialExpirationAlertProps> = ({
  trialExpiresAt,
  className = "",
}) => {
  const timeText = useMemo(
    () => getTrialTimeRemaining(trialExpiresAt),
    [trialExpiresAt]
  );

  if (!timeText) {
    return null;
  }

  return (
    <div
      className={`flex items-center gap-3 px-5 py-4 mb-6 bg-sky-50 border border-sky-100 rounded-xl dark:bg-sky-950/30 dark:border-sky-900 ${className}`}
      role="status"
    >
      <Sparkles className="h-5 w-5 flex-shrink-0 text-sky-600 dark:text-sky-400" />
      <div className="text-left">
        <div className="text-sky-950 dark:text-sky-100 font-medium">
          Trial active: {timeText} remaining
        </div>
        <div className="text-sky-700 dark:text-sky-400 text-sm">
          Full access to all reports and sectors
        </div>
      </div>
    </div>
  );
};

export default TrialExpirationAlert;
